export default __webpack_public_path__ + "static/media/cre-selected.6b346cf3.svg";